export default __webpack_public_path__ + "static/media/TESTIMONI-MARIANA.23f27dcd.jpg";